import type { PageContent } from "../types";

export const p_local_seo_in_2022: PageContent = {
  slug: "local-seo-in-2022",
  title: `Local SEO in 2022 | Phil Carr SEO Consultant`,
  description: `Local search continued to evolve in 2022 with new features in Google Business Profile, changes to local ranking factors, and updates to local service ads.…`,
  date: "",
  lastUpdated: "2026-06-27",
  body: `# Local SEO in 2022

![Local SEO in 2022 featured image](/images/blog/generated/local-seo-in-2022.jpg)

**Published:** June 15, 2022

## New Features and Updates

Local search continued to evolve in 2022 with new features in Google Business Profile, changes to local ranking factors, and updates to local service ads. Google rolled out the “vicinity” update at the end of 2021, which carried over into 2022, giving more weight to proximity in local results.

Businesses that were physically closer to the searcher or their designated service area gained an advantage. The platform also introduced new attributes for businesses such as “LGBTQ‑friendly” or “family‑led,” allowing customers to make more informed decisions.

## Optimising for Local Success

To stay competitive, ensure your business profile is accurate and complete. Update your service area, hours, and contact details regularly.

Add photos and videos that showcase your products or premises, and use the Q&A feature to answer common questions. Encourage customers to leave reviews and respond thoughtfully to each one.

For service area businesses, clearly outline the boundaries you serve. If you have multiple locations, create separate landing pages with unique content and local keywords.

## The Importance of Reviews and Reputation

Reviews remain a crucial ranking factor in local SEO. Encourage satisfied customers to share their experiences, and address negative reviews constructively.

Search engines look at both the number and quality of reviews, as well as how actively businesses engage with them. A strong reputation not only boosts rankings but also builds trust with potential customers.

## SEO Takeaways and Next Steps

Local search is dynamic and increasingly personalised. By staying on top of new features and actively engaging with your community, you can secure a prominent place in local results. If you need help managing your local SEO, contact info@phil‑carr.co.uk or 01226 697 325 for expert support.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Key Takeaways

- **New Features and Updates:** Local search continued to evolve in 2022 with new features in Google Business Profile, changes to local ranking factors, and updates to local service ads.
- **Optimising for Local Success:** To stay competitive, ensure your business profile is accurate and complete.
- **The Importance of Reviews and Reputation:** Reviews remain a crucial ranking factor in local SEO.

## Update — June 2026

Reviewed in June 2026 against the last two core update roll-outs. The bit that's aged best is the emphasis on primary content quality over surface tweaks; the bit worth re-reading is the section on recovery timelines — they've stretched to closer to two full crawl cycles.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)](/blog/2023-seo-lessons-and-forward-view)

### [2023 SEO Lessons and Forward View](/blog/2023-seo-lessons-and-forward-view)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
